// extracted by mini-css-extract-plugin
export default {"serviceItemContainer":"ServiceItem_serviceItemContainer__6ubuO"};